import React, { createContext, useMemo, useState } from "react";
import { Snackbar } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { AlertSeverity } from "../enum/AlertSeverity";

export const AlertContext = createContext({
  onSuccess: () => {},
  onError: () => {},
  onWarning: () => {},
  onInfo: () => {},
});

export const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState(null);
  const [open, setOpen] = useState(false);

  const handleOnClose = (_event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const showAlert = (severity, message) => {
    setAlert({ severity, message });
    setOpen(true);
  };

  const onSuccess = (message) => {
    showAlert(AlertSeverity.SUCCESS, message);
  };

  const onError = (message) => {
    showAlert(AlertSeverity.ERROR, message);
  };

  const onWarning = (message) => {
    showAlert(AlertSeverity.WARNING, message);
  };

  const onInfo = (message) => {
    showAlert(AlertSeverity.INFO, message);
  };

  const contextValue = useMemo(
    () => ({
      onSuccess,
      onError,
      onWarning,
      onInfo,
    }),
    [onSuccess, onError, onWarning, onInfo]
  );

  return (
    <AlertContext.Provider value={contextValue}>
      {children}
      {alert && (
        <Snackbar
          open={open}
          autoHideDuration={5000}
          onClose={handleOnClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <MuiAlert onClose={handleOnClose} severity={alert.severity}>
            {alert.message}
          </MuiAlert>
        </Snackbar>
      )}
    </AlertContext.Provider>
  );
};
